/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

import { UtilInputNumber } from "../../util/util-input-number";
import { EShapeActionRuntimeMiscInputInput } from "./e-shape-action-runtime-misc-input-input";

export class EShapeActionRuntimeMiscInputNumber extends EShapeActionRuntimeMiscInputInput<
	number,
	UtilInputNumber
> {}
